export const UserMobile = ({row}) => {
    return `${row?.msisdn_country.flag} (${row?.msisdn_country.dial_code})${row?.msisdn}`;
}